import { render, staticRenderFns } from "./PictureTab.vue?vue&type=template&id=33ac913a&scoped=true&"
import script from "./PictureTab.vue?vue&type=script&lang=js&"
export * from "./PictureTab.vue?vue&type=script&lang=js&"
import style0 from "./PictureTab.vue?vue&type=style&index=0&id=33ac913a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ac913a",
  null
  
)

export default component.exports